/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef } from "react";
import {
  Modal,
  Button,
  Form,
  Col,
  Popover,
  Row,
  Spinner,
  CloseButton,
} from "react-bootstrap";
import MaskedInput from "react-text-mask";
import userService from "../../api-service/UserService";
import SessionHelper from "../../helpers/SessionHelper";
import FluentdHelper from "../../helpers/FluentdHelper";
import {
  ADD_SHARE,
  DANGER,
  EMPTY,
  INFO,
  LOGERROR,
} from "../../configurations/Constants";
import ShareFieldService from "../../api-service/ShareFieldService";
import PopUp from "../wdpMap/AlertPopup";
import Alert from "../common/Alert";
import NotifyAdminPopup from "./NotifyAdminPopup";
import _ from "lodash";
import { useSelector } from "react-redux";
import {
  FIELDS_SHARED_SUCCESSFULLY,
  ALREADY_SHARED_FIELD_WITH,
  CANNOT_SHARE_FIELD_WITH_YOURSELF,
  SELECT_USER_TO_SHARE_FIELDS_WITH,
  EMAIL_SENT_SUCCESSFULLY,
  SHARE_FIELDS_WITH,
  SELECT_SHARING_TYPE,
  ERROR_SEARCHING_USER,
  ERROR_SHARING_FIELDS,
  SELECT_ATLEAST_ONE_FIELD_TO_SHARE,
  SHARE_UPTO_50_FIELDS,
  ENTER_MOBILE_NUMBER,
  INVALID_MOBILE_NUMBER,
} from "../../configurations/MessageConstants";
import FieldDetailsWarning from "./FieldDetailsWarning";
import { StatusCodes } from "../../configurations/status-codes";

function FieldSharePopUp(props) {
  const loggedInUser = useSelector((state) => state.user.loggedInUser);

  const chkEditor = useRef(false);
  const chkReadonly = useRef(false);
  const chkshareuser = useRef(false);
  const [sharedUser, setSharedUser] = useState(EMPTY);
  const [shareUserDetails, setShareUserDetails] = useState({});
  const [fieldError, setFieldError] = useState(false);
  const [fieldAlertMessage, setFieldAlertMessage] = useState(EMPTY);
  const [fieldVariant, setFieldVariant] = useState(EMPTY);
  const [phoneNumber, setPhoneNumber] = useState(EMPTY);
  const [validated, setValidated] = useState(false);
  const [seachClick, setSeachClick] = useState(false);
  const [accessChecked, setAccessChecked] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [header, setHeader] = useState(EMPTY);
  const [warningActionType, setWarningActionType] = useState(EMPTY);
  const [confirmPopupMessage, setConfirmPopupMessage] = useState(EMPTY);
  const [shareClicked, setShareClicked] = useState(false);
  const [shareUserChecked, setShareUserChecked] = useState(false);
  const [savedSuccessfully, setSavedSuccessfully] = useState(false);
  const [showNotifyAdminPopup, setShowNotifyAdminPopup] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  const handlePhoneNumberOnChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    setSeachClick(false);
    setSharedUser(EMPTY);
    setShareUserChecked(false);
    setShareUserDetails({});
  };

  const handleCloseModal = () => {
    props.closeModal();
  };

  const handleRenderSelectedFields = () => {
    const { selectedFieldsOnPanel } = props;
    return selectedFieldsOnPanel.map((field) => field.fieldName);
  };

  const handleSearchClick = async (event) => {
    event.persist();
    event.preventDefault();
    event.stopPropagation();
    await SessionHelper.handleRefreshToken();

    const form = event.target;
    setSeachClick(true);
    setSharedUser(EMPTY);
    setShareUserChecked(EMPTY);
    setShareUserDetails({});
    if (form.checkValidity() === false) {
      setValidated(true);
      setSeachClick(false);
      return false;
    } else {
      const phoneNumberValue = phoneNumber.replace(/\D+/g, EMPTY);
      const payload = {
        search: [
          {
            key: "PHONE",
            value: phoneNumberValue,
          },
        ],
      };
      try {
        const response = await userService.getUserDetails(payload);
        const respData = response.data;
        if (response && Object.keys(response).length > 0) {
          const user_name = `${respData.data.first_name}  ${respData.data.last_name}`;
          const user_details = {
            user_id: respData.data.user_id,
            last_name: respData.data.last_name,
            phone: respData.data.phone,
            user_email: respData.data.email,
            first_name: respData.data.first_name,
          };
          setSharedUser(user_name);
          setShareUserDetails(user_details);
          setFieldAlertMessage(EMPTY);
          setFieldVariant(EMPTY);
          setFieldError(false);
        }
      } catch (error) {
        console.error(ERROR_SEARCHING_USER, error);
        const responseData = error.response.data;
        if (
          error.response.status === StatusCodes.BAD_REQUEST &&
          responseData.message.includes(CANNOT_SHARE_FIELD_WITH_YOURSELF)
        ) {
          setSharedUser(EMPTY);
          setShareUserDetails({});
          setFieldAlertMessage(responseData.message);
          setFieldVariant(DANGER);
          setFieldError(true);
        } else if (error.response.status === StatusCodes.BAD_REQUEST) {
          setSharedUser(EMPTY);
          setShareUserDetails({});
          setFieldAlertMessage(responseData.message);
          setFieldVariant(DANGER);
          setFieldError(false);
          setShowNotifyAdminPopup(true);
        } else {
          FluentdHelper.logEvent(
            ERROR_SEARCHING_USER,
            "ShareField_handleSearchUser",
            "undefined",
            {
              request: payload,
              response: error,
            },
            LOGERROR
          );
        }
      }
      setValidated(false);
      setSeachClick(false);
    }
  };

  const closeFieldDetailsAlert = () => {
    setFieldAlertMessage(" ");
    setFieldVariant(EMPTY);
    setFieldError(false);
  };

  const handleAccessChecked = (type) => {
    if (
      chkReadonly.current.checked === false &&
      chkEditor.current.checked === false
    ) {
      return;
    }

    if (type === 1) {
      chkReadonly.current.checked = false;
    }
    if (type === 2) {
      chkEditor.current.checked = false;
    }
    setAccessChecked(false);
  };

  const handleShareFieldConfirmation = () => {
    setShowConfirmPopup(true);
    setShowWarning(true);
    setHeader("Share field");
    setWarningActionType(ADD_SHARE);
    setConfirmPopupMessage(
      `${SHARE_FIELDS_WITH} '${sharedUser.toString().toUpperCase()}'?`
    );
  };

  const handleShareField = (e) => {
    setShareClicked(true);
    setAccessChecked(false);
    setShareUserChecked(false);
    const form = e.currentTarget.form;
    if (form.checkValidity() === false) {
      setValidated(true);
      setShareClicked(false);
      return false;
    } else if (
      !chkshareuser.current ||
      chkshareuser.current.checked === false
    ) {
      setFieldAlertMessage(SELECT_USER_TO_SHARE_FIELDS_WITH);
      setFieldVariant(DANGER);
      setFieldError(true);
      setShareClicked(false);
      setValidated(true);
      setShareUserChecked(true);
    } else if (
      chkEditor.current.checked === false &&
      chkReadonly.current.checked === false
    ) {
      setFieldAlertMessage(SELECT_SHARING_TYPE);
      setFieldVariant(DANGER);
      setFieldError(true);
      setShareClicked(false);
      setValidated(true);
      setAccessChecked(true);
    } else {
      if (Object.keys(shareUserDetails).length > 0) {
        handleShareFieldConfirmation();
      }
    }
  };

  const performWarningAction = async (e, idx) => {
    await SessionHelper.handleRefreshToken();

    if (warningActionType !== ADD_SHARE) return;

    const user_email = loggedInUser;
    const { selectedFieldsOnPanel } = props;
    const fields = [];
    for (let i = 0; i < selectedFieldsOnPanel.length; i++) {
      fields.push({
        field_name: selectedFieldsOnPanel[i].fieldName,
        field_id: selectedFieldsOnPanel[i].fieldId,
        editor: chkEditor.current.checked === true ? true : false,
      });
    }
    const payload = {
      share_fields: fields,
      secondary_user_email: shareUserDetails.user_email,
    };
    try {
      await ShareFieldService.addShareFieldDetails(payload);
      await props.clearAllSelectedFields();
      setShowConfirmPopup(false);
      setShowWarning(false);
      setHeader(EMPTY);
      setConfirmPopupMessage(EMPTY);
      setFieldAlertMessage(FIELDS_SHARED_SUCCESSFULLY);
      setFieldVariant(INFO);
      setFieldError(true);
      setShareClicked(false);
      setValidated(false);
      setSharedUser(EMPTY);
      setShareUserDetails({});
      setSeachClick(false);
      setAccessChecked(false);
      setPhoneNumber(EMPTY);
      setWarningActionType(EMPTY);
      setSavedSuccessfully(true);

      if (chkEditor.current && chkReadonly.current) {
        chkEditor.current.checked = false;
        chkReadonly.current.checked = false;
      }
    } catch (error) {
      console.error(ERROR_SHARING_FIELDS, error);
      const respData = error.response.data;
      const alertMessage = respData.message.includes("already shared")
        ? `${ALREADY_SHARED_FIELD_WITH} ${sharedUser.toString().toUpperCase()}.`
        : respData.message;
      setShowConfirmPopup(false);
      setShowWarning(false);
      setHeader(EMPTY);
      setConfirmPopupMessage(EMPTY);
      setFieldAlertMessage(alertMessage.replace(/,/g, ", "));
      setFieldVariant(DANGER);
      setFieldError(true);
      setShareClicked(false);
      setValidated(false);
      setSavedSuccessfully(
        error.response.status === StatusCodes.BAD_REQUEST
          ? savedSuccessfully
          : false
      );

      FluentdHelper.logEvent(
        ERROR_SHARING_FIELDS,
        "ShareField_performWarningAction",
        user_email,
        {
          request: payload,
          response: error,
        },
        LOGERROR
      );
    }
  };

  const handleShareFieldClick = () => {
    const status = chkshareuser.current.checked ? false : true;
    setShareUserChecked(status);
  };

  const closeWarningPopup = () => {
    setShowConfirmPopup(false);
    setConfirmPopupMessage(EMPTY);
    setShowWarning(false);
    setHeader(EMPTY);
    setShareClicked(false);
  };

  const handleAfterSuccessfulEmailSent = () => {
    setFieldAlertMessage(EMAIL_SENT_SUCCESSFULLY);
    setFieldVariant(INFO);
    setFieldError(true);
    setShowNotifyAdminPopup(false);
  };

  const closeNotifyAdminPopup = () => {
    setShowNotifyAdminPopup(false);
  };

  const generateFieldNameString = (fields) => {
    return fields.map((field) => field.FieldName);
  };

  const closeModal = () => {};

  const sharedFieldsByOtherUser = [];
  const { selectedFieldsOnPanel } = props;
  let allSharedFieldsByOtherUser = EMPTY;
  let fields = [];

  if (selectedFieldsOnPanel.length > 1) {
    fields = handleRenderSelectedFields();
    fields = fields.toString();
  }
  _.forEach(selectedFieldsOnPanel, (value) => {
    if (value.fieldSharedByOtherUser) {
      const fieldName = {};
      fieldName.FieldName = value.fieldName;
      sharedFieldsByOtherUser.push(fieldName);
    }
  });
  allSharedFieldsByOtherUser = generateFieldNameString(sharedFieldsByOtherUser);
  allSharedFieldsByOtherUser = allSharedFieldsByOtherUser.toString();
  return (
    <Modal show className="field-details" onHide={closeModal}>
      <Modal.Header>
        <Modal.Title>{"Field Share"}</Modal.Title>
        <CloseButton
          className="close field-details-close"
          onClick={(event) => handleCloseModal(event)}
        />
      </Modal.Header>
      <Modal.Body>
        <div id="ShareFieldPopup">
          <Popover.Body>
            {fieldError ? (
              <Alert
                key="messageAlert"
                variant={fieldVariant}
                closeAlert={(e) => closeFieldDetailsAlert(e)}
                alertMessage={fieldAlertMessage}
                dismissible
              />
            ) : (
              EMPTY
            )}
            {selectedFieldsOnPanel.length === 0 &&
            savedSuccessfully === false ? (
              <div id="noSelectedFields" className="no-field-selected">
                <div className=" text-center">
                  <FieldDetailsWarning
                    message={SELECT_ATLEAST_ONE_FIELD_TO_SHARE}
                    dismissible={false}
                  />
                </div>
              </div>
            ) : (
              EMPTY
            )}
            {selectedFieldsOnPanel.length > 50 &&
            savedSuccessfully === false ? (
              <div id="noSelectedFields" className="no-field-selected">
                <div className=" text-center">
                  <FieldDetailsWarning
                    message={SHARE_UPTO_50_FIELDS}
                    dismissible={false}
                  />
                </div>
              </div>
            ) : (
              EMPTY
            )}
            {savedSuccessfully === true && (
              <div id="noSelectedFields" className="no-field-selected">
                <div className=" text-center">
                  <span style={{ fontSize: "150px" }}>
                    <i className="fa fa-check-circle"></i>
                  </span>
                </div>
              </div>
            )}
            {sharedFieldsByOtherUser.length !== 0 &&
              selectedFieldsOnPanel.length > 0 &&
              selectedFieldsOnPanel.length < 51 && (
                <div id="noSelectedFields" className="no-field-selected">
                  <div className=" text-center">
                    <FieldDetailsWarning
                      message={
                        <>
                          The Field(s) listed below are shared with you. Fields
                          can only be shared by the user who registers the
                          Field. Please de-select the Field(s):{" "}
                          <strong>
                            {allSharedFieldsByOtherUser.replace(/,/g, ", ")}
                          </strong>
                          .
                        </>
                      }
                      dismissible={false}
                    />
                  </div>
                </div>
              )}
            {sharedFieldsByOtherUser.length === 0 &&
              selectedFieldsOnPanel.length > 0 &&
              selectedFieldsOnPanel.length < 51 && (
                <Form
                  key="popoverForm"
                  noValidate
                  validated={validated}
                  onSubmit={(event) => handleSearchClick(event)}
                >
                  <div className="text-center shareFieldPopupForm">
                    <Row className="share-field-label-row">
                      <Form.Group
                        as={Col}
                        md="12"
                        className="shareFieldTableHeader"
                      >
                        <label>
                          Who do you want to share with and what is the
                          relationship to the account to be shared?
                        </label>
                      </Form.Group>
                    </Row>

                    {selectedFieldsOnPanel.length > 1 ? (
                      <Row className="share-field-label-row">
                        <Form.Group
                          as={Col}
                          md="2"
                          className="mb-0"
                        ></Form.Group>
                        <Form.Group as={Col} md="3" className="mb-0">
                          <p className="text-end fw-bold shareFieldAttributeFont">
                            Selected Fields:
                          </p>
                        </Form.Group>
                        <Form.Group as={Col} md="6" className="text-start mb-0">
                          {}
                          <p className="shareFieldAttributeFont">
                            {fields.replace(/,/g, ", ")}
                          </p>
                        </Form.Group>{" "}
                      </Row>
                    ) : (
                      <Row className="share-field-label-row">
                        {" "}
                        <Form.Group
                          as={Col}
                          md="2"
                          className="mb-0"
                        ></Form.Group>
                        <Form.Group as={Col} md="3" className="mb-0">
                          <p className="text-end fw-bold shareFieldAttributeFont mb-0">
                            Selected Field:
                          </p>
                        </Form.Group>
                        <Form.Group as={Col} md="6" className="text-start mb-0">
                          <p className="shareFieldAttributeFont fw-bold mb-0">
                            {selectedFieldsOnPanel[0].fieldName}
                          </p>
                          <ul className="no-padding-ul">
                            <li>
                              <span className="fw-bold ">Certified Acres:</span>{" "}
                              {selectedFieldsOnPanel[0].fieldAcres}
                            </li>
                            <li>
                              <span className="fw-bold "> Farm:</span>{" "}
                              {selectedFieldsOnPanel[0].fieldFarm}
                            </li>
                            <li>
                              <span className="fw-bold "> Business:</span>{" "}
                              {selectedFieldsOnPanel[0].fieldBusiness}
                            </li>
                          </ul>
                        </Form.Group>{" "}
                      </Row>
                    )}

                    <Row className="share-field-label-row">
                      <Form.Group as={Col} md="5" className="mb-0">
                        <p className="text-end mb-0 fw-bold shareFieldAttributeFont">
                          Mobile Phone Number:
                        </p>
                      </Form.Group>
                    </Row>
                    <Row className="share-field-label-row">
                      <Form.Group as={Col} md="5">
                        <MaskedInput
                          type="text"
                          size="sm"
                          name="phoneNumber"
                          className="form-control form-control-sm text-end"
                          required
                          value={phoneNumber}
                          onChange={handlePhoneNumberOnChange}
                          pattern="^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$"
                          mask={[
                            "(",
                            /[1-9]/,
                            /\d/,
                            /\d/,
                            ")",
                            " ",
                            /\d/,
                            /\d/,
                            /\d/,
                            "-",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                        />
                        <Form.Control.Feedback type="invalid">
                          {phoneNumber === EMPTY
                            ? ENTER_MOBILE_NUMBER
                            : INVALID_MOBILE_NUMBER}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="2" className="text-start">
                        {seachClick ? (
                          <div className="share-field-search">
                            <a>
                              <i className="fa fa-search"></i>
                            </a>
                          </div>
                        ) : (
                          <div className="highlight-field">
                            <Button type="submit" className="customise-search">
                              <i className="fa fa-search black-color"></i>
                            </Button>
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} md="5" className=" text-start">
                        {sharedUser !== EMPTY && (
                          <Form.Check
                            name="sharedUserName"
                            label={sharedUser}
                            id="chkshareuser"
                            ref={chkshareuser}
                            onClick={() => handleShareFieldClick()}
                            className={
                              shareUserChecked
                                ? "text-uppercase fw-bold shareUsercheckbox color-red"
                                : "text-uppercase fw-bold shareUsercheckbox"
                            }
                          />
                        )}
                      </Form.Group>
                    </Row>
                    <Row className="share-field-label-row">
                      <Form.Group as={Col} md="5"></Form.Group>
                    </Row>
                    <Row className="share-field-label-row">
                      <Form.Group as={Col} md="5" className="mb-0">
                        <p className="text-end mb-0 fw-bold shareFieldAttributeFont">
                          Sharing Type:
                        </p>
                      </Form.Group>
                      <Form.Group as={Col} md="2" className=" text-start">
                        <label>
                          <Form.Check
                            name="sharedUserName"
                            label="Editor"
                            id="chkEditor"
                            ref={chkEditor}
                            defaultChecked={true}
                            onClick={() => handleAccessChecked(1)}
                            className={
                              accessChecked
                                ? "text-uppercase color-red"
                                : "text-uppercase "
                            }
                          />
                        </label>
                      </Form.Group>
                      <Form.Group as={Col} md="4" className=" text-start">
                        <label className="ps-0">
                          <Form.Check
                            name="sharedUserName"
                            label="Read Only"
                            id="chkReadonly"
                            ref={chkReadonly}
                            className={
                              accessChecked
                                ? "text-uppercase color-red"
                                : "text-uppercase "
                            }
                            onClick={() => handleAccessChecked(2)}
                          />
                        </label>
                      </Form.Group>
                    </Row>
                    <Row className="share-field-label-row">
                      <Form.Group as={Col} md="3" className=" text-start">
                        <Button onClick={(e) => handleShareField(e)}>
                          {shareClicked ? (
                            <div>
                              <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />{" "}
                              <span>Sharing</span>
                            </div>
                          ) : (
                            "Share"
                          )}
                        </Button>{" "}
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="4"
                        className=" text-start"
                      ></Form.Group>
                    </Row>
                  </div>
                </Form>
              )}

            {showWarning && (
              <PopUp
                showConfirmPopup={showConfirmPopup}
                message={confirmPopupMessage}
                closeWarningPopup={(e) => closeWarningPopup(e)}
                performWarningAction={(e, idx) => performWarningAction(e, idx)}
                header={header}
              />
            )}
            {showNotifyAdminPopup && (
              <NotifyAdminPopup
                showNotifyAdminPopup={showNotifyAdminPopup}
                closePopup={(e) => closeNotifyAdminPopup(e)}
                mobilePhoneNumber={phoneNumber}
                fields={props.selectedFieldsOnPanel}
                afterSuccessful={(e) => handleAfterSuccessfulEmailSent()}
              ></NotifyAdminPopup>
            )}
          </Popover.Body>
        </div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}

export default FieldSharePopUp;
